module.exports = __webpack_public_path__ + "kuenne.50a2df03e7c1cee51c631259e7580138.png";